import { defineWorkflow } from './workflow-builder'

/**
 * WF-GAB-01 (Merge Request / Penggabungan Barang Lepas FG) — nomor workflow 11.
 * ERD v010 `merge_request` hanya memuat `png_no`, `operator_id`, `merge_status`; kolom `status_id` / `submission_id` ditambahkan
 * sebagai [ERD-GAP] (laporan 14). Tidak ada 12B untuk GAB, jadi alur mengikuti 03A + prototype v7.44.
 *
 * - Permintaan ALM (Slop / Bal) lahir otomatis dari start mesin ALM dan berstatus Menunggu persetujuan. v7.50 (A-01 / A-02):
 *   tahap eskalasi dihapus — Admin menyetujui ATAU menolak (`ACT_GAB_REJECT`, alasan wajib, semua jenis) kapan saja;
 *   lewat batas Master SLA `GAB_ALM_AUTO_APPROVE` sistem menyetujui (`ACT_GAB_AUTO_APPROVE`, tanpa aktor manusia, dijalankan
 *   `autoApproveSweep()` di handler) dan Supervisor hanya diberi tahu. Aturan yang dimatikan tidak pernah menjalankan aksi ini.
 * - Permintaan Pack dibuat Admin (+ petugas + area tujuan) dan langsung disetujui oleh pembuatnya.
 * - Mode Kembalikan (ALM batal produksi) dan sesi Operator ALM tidak dibawa ke mvdp (laporan 14).
 */
export const WF_GAB = defineWorkflow({
  no: 11,
  code: 'WF-GAB-01',
  name: 'Merge Request FG Workflow',
  entity: 'merge_request',
  statuses: [
    [
      'GAB_PENDING',
      'Menunggu persetujuan',
      true,
      false,
      '#F59E0B',
      'Permintaan ALM terbit otomatis, menunggu persetujuan'
    ],
    ['GAB_READY', 'Menunggu diambil', false, false, '#3B82F6', 'Disetujui — tugas ambil terbit untuk operator'],
    ['GAB_PICKING', 'Diambil', false, false, '#06B6D4', 'Operator mengambil barang lepas dari rak / container'],
    ['GAB_DONE', 'Selesai', false, true, '#10B981', 'Barang tiba di Area ALM / diserahkan ke produksi'],
    ['GAB_CANCELLED', 'Dibatalkan', false, true, '#6B7280', 'Permintaan pack dibatalkan Admin'],
    ['GAB_REJECTED', 'Ditolak', false, true, '#6B7280', 'Admin menolak permintaan — barang dilepas, blokir ALM dibuka']
  ],
  actors: [
    ['ACT_GAB_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_GAB_OP_FG', 'Operator WH FG', 'operator_wh_fg', null]
  ],
  components: [
    ['CMP_GAB_APPROVE', 'Tombol Setujui Permintaan', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_GAB_PICK', 'Tombol Mulai Ambil', 'ACTION', {}],
    ['CMP_GAB_COMPLETE', 'Tombol Selesai Ambil / Serah', 'ACTION', {}],
    ['CMP_GAB_CANCEL', 'Tombol Batalkan Permintaan Pack', 'ACTION', {}],
    ['CMP_GAB_REJECT', 'Tombol Tolak Permintaan', 'ACTION', {}],
    ['CMP_GAB_AUTO_APPROVE', 'Aksi Auto-Approve Permintaan ALM', 'ACTION', {}],
    ['CMP_GAB_PANEL_HEADER', 'Panel Header Permintaan', 'PANEL', {}],
    ['CMP_GAB_PANEL_ITEMS', 'Panel Isi Permintaan', 'PANEL', {}]
  ],
  actions: [
    ['ACT_GAB_APPROVE', 'GAB_PENDING', 'GAB_READY', 'CMP_GAB_APPROVE', false, false, null],
    ['ACT_GAB_START_PICK', 'GAB_READY', 'GAB_PICKING', 'CMP_GAB_PICK', false, false, null],
    ['ACT_GAB_COMPLETE', 'GAB_PICKING', 'GAB_DONE', 'CMP_GAB_COMPLETE', false, false, { completed_at: '$NOW' }],
    ['ACT_GAB_CANCEL_READY', 'GAB_READY', 'GAB_CANCELLED', 'CMP_GAB_CANCEL', true, true, null],
    ['ACT_GAB_CANCEL_PICKING', 'GAB_PICKING', 'GAB_CANCELLED', 'CMP_GAB_CANCEL', true, true, null],
    ['ACT_GAB_REJECT', 'GAB_PENDING', 'GAB_REJECTED', 'CMP_GAB_REJECT', true, true, null],
    ['ACT_GAB_AUTO_APPROVE', 'GAB_PENDING', 'GAB_READY', 'CMP_GAB_AUTO_APPROVE', false, false, null]
  ],
  eligibility: [
    ['ACT_GAB_APPROVE', 'ACT_GAB_ADMIN_FG'],
    ['ACT_GAB_REJECT', 'ACT_GAB_ADMIN_FG'],
    ['ACT_GAB_START_PICK', 'ACT_GAB_OP_FG'],
    ['ACT_GAB_COMPLETE', 'ACT_GAB_OP_FG'],
    ['ACT_GAB_CANCEL_READY', 'ACT_GAB_ADMIN_FG'],
    ['ACT_GAB_CANCEL_PICKING', 'ACT_GAB_ADMIN_FG']
  ],
  panels: [
    ['CMP_GAB_PANEL_HEADER', 'GAB_PENDING', 'read', null],
    ['CMP_GAB_PANEL_HEADER', 'GAB_READY', 'read', null],
    ['CMP_GAB_PANEL_ITEMS', 'GAB_PENDING', 'read', null],
    ['CMP_GAB_PANEL_ITEMS', 'GAB_PICKING', 'write', 'ACT_GAB_OP_FG']
  ],
  emailStatuses: ['GAB_PENDING']
})

export type GabStatusCode = (typeof WF_GAB.spec.statuses)[number][0]
export type GabActorCode = (typeof WF_GAB.spec.actors)[number][0]
export type GabActionName = (typeof WF_GAB.spec.actions)[number][0]
export const buildWorkflowGabSeed = WF_GAB.build
